


















    import { IFlight, ITour } from '@/store/models';
    import { Component, Prop } from 'vue-property-decorator';
    import { namespace, State } from 'vuex-class';
    import { formatter } from '../app.config';
    import Calculator from '../helpers/calculator';
    import { ScrollAnchor } from '../store/modules/ui';
    import BaseComponent from './Base';

    const UiStore = namespace('ui');

    @Component
export default class TourPrice extends BaseComponent {
    @Prop({ type: String, default: '%s' }) protected readonly format: string;

    @Prop({ type: Number }) protected readonly sid: ITour['sid'];

    @Prop({ type: String, default: null }) protected readonly price: string | null;

    @State('flights', { namespace: 'orm' }) protected readonly storedFlights: IFlight[];

    @Prop({ type: Boolean, default: false }) protected readonly link: boolean;

    @UiStore.State('scrollAnchors') protected readonly scrollAnchors: ScrollAnchor[];

    get priceAnchor(): ScrollAnchor | null {
        return this.scrollAnchors.find((anchor) => anchor.id === 'prices') || null;
    }

    get hasPrefix(): boolean {
        return !!this.$slots.hasOwnProperty('prefix');
    }

    get hasSuffix(): boolean {
        return !!this.$slots.hasOwnProperty('suffix');
    }

    protected get flight(): IFlight | null {
        return this.storedFlights.find(({ tourSid }) => tourSid === this.sid) || null;
    }

    get cheapestPrice(): string | null {
        let min = this.price;

        if (this.price === null) {
            min = Calculator.minPrice(this.flight ? this.flight.prices.map(({ adultPrice }) => adultPrice) : []);
        }

        return min ? this.format.replace('%s', formatter.asCurrency(min)) : null;
    }

    public onClick() {
        if (this.priceAnchor === null) {
            return;
        }

        window.scrollTo({
            top: (this.priceAnchor.el.elm as HTMLElement).offsetTop - 100,
            behavior: 'smooth',
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TourPrice.vue